<template>
  <template v-if="hasUnread">
    <slot :open-notifications-sheet="() => open = true" />
    <MobileSheet
      v-model:open="open"
      title="Notifications"
    >
      <div class="px-6">
        <AppNotifications
          :notifies
          :errors
          @click:item="open = false"
        />
      </div>
    </MobileSheet>
  </template>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useAppNotifications } from '../utils/useAppNotifications'

import MobileSheet from './MobileSheet.vue'
import { AppNotifications } from '@app'

const { errors, notifies, hasUnread } = useAppNotifications()

const open = ref(false)
</script>
